import { render } from "./index-5.vue?vue&type=template&id=0f024a03&scoped=true"
const script = {}

import "./index-5.vue?vue&type=style&index=0&id=0f024a03&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f024a03"]])

export default __exports__